export default "__VITE_ASSET__Baj$iC0___"